import React from 'react';

import { YACHT } from 'constants/boatApplication';

import http from 'api/http';
import { boatAPI } from 'api/requests';

import { Input } from 'Components/Input';
import Select, { selectType } from 'Components/Select';
import NotificationManager from 'dom-managers/notification';

const PLATE_TYPE_OPTIONS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

export default class BoatsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      boatListRequestInProcess: true,
      availableBoatsList: [],
      boatsListYear: '',
    };
  }

  componentDidMount() {
    this.updateBoatsList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.reportYear !== this.state.boatsListYear) {
      this.updateBoatsList();
    }
  }

  updateBoatsList = () => {
    const { reportYear } = this.props;

    if (reportYear) {
      this.setState({ boatsListYear: reportYear, boatListRequestInProcess: true }, () => {
        http.get(boatAPI.approvedBoatsByYear(reportYear)).then(({ data }) => {
          this.setState({ availableBoatsList: data, boatListRequestInProcess: false });
          if (!data.length)
            NotificationManager.error(
              'note',
              'Cannot generate a Capacity tag report: there are no approved boat models for a selected year.'
            );
        });
      });
    } else {
      this.setState({ boatsListYear: reportYear, availableBoatsList: [], boatListRequestInProcess: false });
    }
  };

  getPlateTypeOption = plateType => {
    if (!plateType) return '';

    return plateType.toString().replace('PLATE_TYPE_', '');
  };

  render() {
    const {
      selectedBoatsList,
      reportSubType,
      tagType,
      addBoat,
      removeBoat,
      handleBoatParamChange,
      inputErrors,
      reportYear,
    } = this.props;
    const { boatListRequestInProcess, availableBoatsList } = this.state;

    return (
      <section className='report-boat-list-section'>
        <header>Report Boat List</header>
        <Select
          multiSelect
          mainWrapperClassName='_width_450'
          type={selectType.primarySmall}
          disabled={!reportYear || !availableBoatsList.length}
          isLoading={boatListRequestInProcess}
          selectionList={availableBoatsList.filter(boat => {
            return (
              (tagType !== 'Mylar' || boat.boatType !== YACHT) &&
              !selectedBoatsList.find(selectedBoat => {
                return selectedBoat.id === boat.id;
              })
            );
          })}
          error={inputErrors.selectedBoatsList}
          itemNameIndicator={['id', 'name']}
          handleSelect={addBoat}
          placeholder='ID or Model Name'
        />
        <div className={`boats-list ${reportSubType === 'CARB' ? 'with-CARB-fields' : ''}`}>
          <div>
            <div className='column model-name'>Model Name</div>
            <div className='column id'>ID</div>
            
            {reportSubType === 'CARB' && (
              <React.Fragment>
                <div className='column EVAP-family'>California EVAP Family*</div>
                <div className='column emission'>
                  Emission <br />
                  Control System*
                </div>
              </React.Fragment>
            )}
            <div className='column qty'>Qty</div>
            <div className='column remove'>Remove</div>
          </div>
          {selectedBoatsList.map((boat, index) => {
            return (
              <div key={`componentRow${boat.id}`}>
                <div className='column model-name'>{boat.name}</div>
                <div className='column id'>{boat.id}</div>
                
                {reportSubType === 'CARB' && (
                  <React.Fragment>
                    <div className='column EVAP-family'>
                      <Input
                        value={boat.EVAPFamily}
                        inputClassName='_border_radius_10 _height_20 _width_110'
                        error={
                          inputErrors.boatsListErrors &&
                          inputErrors.boatsListErrors[boat.id] &&
                          inputErrors.boatsListErrors[boat.id].EVAPFamily
                        }
                        onChange={handleBoatParamChange(boat.id, index, 'EVAPFamily')}
                      />
                    </div>
                    <div className='column emission'>
                      <Input
                        value={boat.emission}
                        inputClassName='_border_radius_10 _height_20 _width_50'
                        error={
                          inputErrors.boatsListErrors &&
                          inputErrors.boatsListErrors[boat.id] &&
                          inputErrors.boatsListErrors[boat.id].emission
                        }
                        onChange={handleBoatParamChange(boat.id, index, 'emission')}
                      />
                    </div>
                  </React.Fragment>
                )}
                <div className='column qty'>
                  <Input
                    isNumeric
                    inputClassName='_border_radius_10 _height_20 _width_50'
                    digitsAfterDot={0}
                    value={boat.qty}
                    error={
                      inputErrors.boatsListErrors &&
                      inputErrors.boatsListErrors[boat.id] &&
                      inputErrors.boatsListErrors[boat.id].qty
                    }
                    onChange={handleBoatParamChange(boat.id, index, 'qty')}
                  />
                </div>
                <div className='column remove'>
                  <div className='delete' onClick={removeBoat(index)} />
                </div>
              </div>
            );
          })}
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ReportScene/CARBReport/BoatsList.jsx